import { Box, CircularProgress } from "@mui/material";

const LoadingBox = () => (
  <Box sx={{ flex: 1, padding: 2, display: "flex", justifyContent: "center", alignItems: "center" }}>
    <CircularProgress />
  </Box>
);

export default LoadingBox;
